import { API_PREFIX, COMPANY_ROUTE } from '@constants'

export const API_ONBOARDING_SETUP = `${API_PREFIX}integrations/szamlazz/onboarding/setup`
export const API_ONBOARDING_CONFIRM = `${API_PREFIX}integrations/szamlazz/onboarding/confirm`
export const API_ONBOARDING_KSZI_CONNECT = `${API_PREFIX}integrations/szamlazz/kszi/connect`
export const API_ONBOARDING_INVITATION_STATUS = `${COMPANY_ROUTE}szamlazz/onboarding-invitation/status`
export const API_ONBOARDING_INVITATION_MEMBERS_LIST = `${COMPANY_ROUTE}szamlazz/onboarding-invitation`
export const API_ONBOARDING_INVITATION_REJECT = `${COMPANY_ROUTE}szamlazz/onboarding-invitation/{uuid}`
